<section class="main-content wrapper content-padding " style="margin-top: 50px;">
    <div class="content-panel">

        <div class="tabs">
            <label class="tab">
                <a class="tab-link active-tab">VALET RICEVUTE</a>
            </label>
        </div>

        
        <div class="button-wrapper">
            <ng-template [ngIf]="selected == 'active'">
                <a class="btn hvr-grow has-margin-right" 
                    [routerLink]="['/expert/receipts/storico']"
                    [queryParamsHandling]="'merge'"
                >
                    <i class="mr-10 far fa-folder"></i>Storico
                </a>
            </ng-template>
        
            <ng-template [ngIf]="selected == 'inactive'">
                <button class="btn hvr-grow has-margin-right" 
                    [routerLink]="['../']"
                    [queryParams]="{ navigation: 'back' }"
                    [queryParamsHandling]="'merge'"
                >
                    <i class="mr-10 fas fa-arrow-left"></i>Ritorna
                </button>
            </ng-template>
        </div>

        <div class="flex-container leggenda">
            <div class="item" *ngFor="let expertReceiptStatus of expertReceiptStatusAux[selected]">
                <span class="status {{expertReceiptStatusAux.css(expertReceiptStatus)}}"></span>
                {{ expertReceiptStatusAux.ln('it', expertReceiptStatus).toUpperCase() }}
            </div>
        </div>
       

        <p class="valet-name">
            <b>
                VALET
                <span *ngIf="selectedExpertId">| {{selectedValet?.user?.surname?.toUpperCase()}} {{selectedValet?.user?.name?.toUpperCase()}}</span>
            </b>
        </p>

        <div class="button-wrapper">
            <div class="grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <label for="sku">VALETS</label>
                <select [(ngModel)]="selectedExpertId" (ngModelChange)="handleValetChange($event)" id="selezionePartner">
                    <option [ngValue]="null" disabled selected>Select Valet</option>
                    <option *ngFor="let expert of experts" [ngValue]="expert.id">{{expert.user.surname}} {{expert.user.name}}</option>
                </select>
            </div>
            
            <div class="grid-element" *ngIf="selected === 'active'">
                <label for="receiptStatus">STATUS</label>
                <select [(ngModel)]="receiptStatus" (ngModelChange)="handleStatusDropdown()" id="requestStatus">
                    <option [ngValue]="null">Tutti</option>
                    <option *ngFor="let status of expertReceiptStatusAux[selected]" [ngValue]="status">
                    {{ expertReceiptStatusAux.ln('it', status) }}
                    </option>
                </select>
            </div>

        </div>

        <div class="column-box">
            <ng-container *ngIf="expertReceipts?.length > 0; else noPayments">
                <div class="column-inner-other-user" *ngFor="let expertReceipt of expertReceipts, index as i"
                [ngClass]="{
                    'status-created-border': expertReceipt.receiptStatus === 'open',
                    'status-approved-border': expertReceipt.receiptStatus === 'approved',
                    'status-paid-border': expertReceipt.receiptStatus === 'paid'
                }"
                >
                    <div class="card-container" (click)="toggleAccordion(i)">
                        <div class="action-btns" 
                            [ngClass]="{
                                'status-created': expertReceipt.receiptStatus === 'open',
                                'status-approved': expertReceipt.receiptStatus === 'approved',
                                'status-paid': expertReceipt.receiptStatus === 'paid'
                            }"
                            >
                            <div class="action-title">
                                <h3>
                                    <b>ID RICEVUTE: #{{ expertReceipt?.id }}</b>
                                </h3>
                            </div>
                            <div class="action-icons">
                                
                                <i matTooltip="Confermata" *ngIf="(expertReceipt.receiptStatus === 'open') && (selected === 'active') && (groups.includes('admin') || groups.includes('operation'))" (click)="handleApproveClick(expertReceipt, $event)" class="material-icons action-icon" style="color: #4CAF50;">
                                    check_circle
                                </i>
                                <i matTooltip="Paid" *ngIf="(expertReceipt.receiptStatus === 'approved') && (selected === 'active') && (groups.includes('admin') || groups.includes('operation'))" (click)="handlePaidClick(expertReceipt, $event)" class="material-icons action-icon" style="color: #009688;">
                                    payments
                                </i>

                                <i 
                                    matTooltip="Upload Receipt" 
                                    *ngIf="(expertReceipt.receiptStatus === 'open') && (selected === 'active') && groups.includes('expert')" 
                                    (click)="receiptInput.click()" 
                                    class="material-icons action-icon" 
                                    style="color: #3f51b5; cursor: pointer;">
                                    receipt_long
                                </i>

                                <input 
                                    #receiptInput 
                                    type="file" 
                                    accept=".pdf" 
                                    (change)="handleReceiptUpload($event, expertReceipt)" 
                                    style="display: none;" 
                                />
                               
                                <i class="material-icons" [ngClass]="{'rotate-icon': true, 'active': activeAccordionActivityIndex === i}">expand_more</i>
                            </div>
                        </div>
                    </div>
                    <div class="accordion-body" *ngIf="activeAccordionActivityIndex === i">
                        <div class="info-container">
                            <div class="event-name">RICEVUTE ID: {{ expertReceipt?.id }}</div>

                            <span>
                                <b>RICEVUTE DATA: </b>{{ expertReceipt?.createdAt | date:'dd/MM/yyyy' }}
                                <br class="clear">
                            </span>

                            <span>
                                <b>VALET: </b>{{ expertReceipt.expert?.user?.surname }} {{ expertReceipt.expert?.user?.name }}
                                <br class="clear">
                            </span>

                            <span>
                                <b>TOTAL VALUE TO PAY: </b>€ {{ expertReceipt?.totalAmount || 0 }}
                                <br class="clear">
                            </span>
                          
                            <span>
                                <b>TO VALET RICEVUTE: </b> 
                                <i
                                    matTooltip="Download Receipt"
                                    *ngIf="expertReceipt?.toReceipt"
                                    class="material-icons action-icon"
                                    style="color: #2196F3; cursor: pointer; position: relative; top: 8px;"
                                    (click)="openReceiptInNewTab(expertReceipt?.toReceipt)"
                                    >
                                    download
                                </i>
                                <br class="clear">
                            </span>

                            <span>
                                <b>FROM VALET RICEVUTE: </b> 
                                <i
                                    matTooltip="Download Receipt"
                                    *ngIf="expertReceipt?.fromReceipt"
                                    class="material-icons action-icon"
                                    style="color: #2196F3; cursor: pointer; position: relative; top: 8px;"
                                    (click)="openReceiptInNewTab(expertReceipt?.fromReceipt)"
                                    >
                                    download
                                </i>
                                <br class="clear">
                            </span>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-template #noPayments>
                <span>NO RICEVUTE YET...</span>
            </ng-template>
        </div>
    </div>
</section>
